import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const MAINDIAGNOSIS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MainDiagnosis.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const MAINDIAGNOSIS_CONFIG = {
  entityName: 'MainDiagnosis',
  localizationKey: 'Planning::Entity.MainDiagnosis',
  fields: MAINDIAGNOSIS_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.MainDiagnoses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
